import React from 'react'

import CustomButton from '../common/buttons/custom-button'

import useStyles from './StoresFilterButton.styles'

function StoresFilterButton({ onClick, text, totalSelectedStoreIds }) {
  const componentClasses = useStyles()

  return (
    <CustomButton
      fullWidth={false}
      onClick={onClick}
      classes={{
        root: componentClasses.rootOfSubmitButton,
        submitButton: componentClasses.submitButton,
      }}
    >
      <div className={componentClasses.container}>
        <div>{text}</div>
        {!!totalSelectedStoreIds && (
          <span className={componentClasses.selectedStoresTotal}>
            &nbsp;{`(${totalSelectedStoreIds})`}
          </span>
        )}
      </div>
    </CustomButton>
  )
}

StoresFilterButton.defaultProps = {
  classes: {},
}

export default StoresFilterButton
